module.exports = __webpack_public_path__ + "img/kiev.b9717a1b.png";